import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {

  productArr: any = [
    {
      id: 101,
      title: 'High Speed Direct Warping Machine',
      image: 'assets/img/products/machine1.jpg',
    },
    {
      id: 102,
      title: 'Warping Creels',
      image: 'assets/img/products/machine2.jpg',
    },
    {
      id: 103,
      title: 'Indigo Dyeing and Sizing Machines',
      image: 'assets/img/products/machine3.jpg',
    },
    {
      id: 104,
      title: 'Indigo Rope Dyeing Machines',
      image: 'assets/img/products/machine4.jpg',
    },
    {
      id: 105,
      title: 'Fabric Singeing Machines',
      image: 'assets/img/products/machine5.jpg',
    },
    {
      id: 106,
      title: 'Loom Cloth Batching Unit',
      image: 'assets/img/products/machine6.jpg',
    },
    {
      id: 107,
      title: 'Fabric Roll Stretch Wrapping Machines',
      image: 'assets/img/products/machine7.jpg',
    }
  ]
  currentTab: any = 1;
  currentIndDetail: any = [];
  productType: string;

  constructor(private route: ActivatedRoute, private router: Router) {
    this.route.paramMap.subscribe(params => {
      this.productType = params.get('type');
    });
  }

  ngOnInit() {
    this.currentIndDetail = this.productArr[0]?.details;
  }

  currentActiveCate(id, ind) {
    this.currentTab = id;
    this.currentIndDetail = this.productArr[ind]?.details;
  }

}
